module.exports = __webpack_public_path__ + "img/unit_White.c8e5f921.png";